import { getDefaultTelephonyProviderId } from "@/features/telephony/adapters/providers/telephony-provider.config";
import { twilioAdapter } from "@/features/telephony/adapters/twilio/twilio.adapter";
import { VonageAdapter } from "@/features/telephony/adapters/vonage/vonage.adapter";
import { TelephonyProvider, TelephonyProviderId } from "@/features/telephony/interfaces/telephony-provider.interface";

type ProviderFactory = () => TelephonyProvider;

export class TelephonyProviderFactory {
    private readonly registry = new Map<TelephonyProviderId, ProviderFactory>();

    register(providerId: TelephonyProviderId, factory: ProviderFactory): void {
        this.registry.set(providerId, factory);
    }

    create(providerId: TelephonyProviderId = getDefaultTelephonyProviderId()): TelephonyProvider {
        const factory = this.registry.get(providerId);

        if (!factory) {
            throw new Error(`Telephony provider "${providerId}" is not registered`);
        }

        return factory();
    }

    getRegisteredProviderIds(): TelephonyProviderId[] {
        return Array.from(this.registry.keys());
    }
}

export const telephonyProviderFactory = new TelephonyProviderFactory();

telephonyProviderFactory.register("twilio", () => twilioAdapter);
telephonyProviderFactory.register("vonage", () => new VonageAdapter());

export const createTelephonyProvider = (providerId?: TelephonyProviderId): TelephonyProvider => {
    return telephonyProviderFactory.create(providerId);
};
